import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";
import { formatDate } from "../../../../components/common/Converter";

class OBRequestFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  async save() {
    const collection = this.view.getCollectionName();
    const object = this.object;

    const user = this.view.getCurrentUser();
    const updateObject = {...object, status: "Pending", employee: user.employee };

    try {
      await this.upsertUseCase.execute(collection, updateObject);
      this.showSuccess("Successfully saved");
    } catch (error) {
      this.showError(error.message);
      throw error;
    }
  }

  onChange(value, field) {
    if(field === "selectedDate"){
      const getDatesInRange = (startStr, endStr) => {
        const dates = [];
      
        let current = new Date(startStr);
        const end = new Date(endStr);
      
        while (current <= end) {
          dates.push(current.toISOString().slice(0, 10));
          current.setDate(current.getDate() + 1);
        }
      
        return dates;
      };
      
      const allDates = Array.isArray(value)
      ? value
          .flat()
          .flatMap(([startDate, endDate]) =>
            startDate && endDate
              ? getDatesInRange(startDate, endDate)
              : []
          )
      : [];

      const uniqueDates = [...new Set(allDates)].sort();

      this.change.selectedDate = value;
      this.object.selectedDate = value;
      this.change.obDates = uniqueDates;
      this.object.obDates = uniqueDates;
      this.view.setObject(this.object);
      return;
    }
    this.change[field] = value;
    this.object[field] = value;
    this.view.setObject(this.object);
  }
}

export default OBRequestFormPresenter;
